import { ExamplePageTemplate } from "./components";
import { realEstateConfig } from "./configs/exampleConfigs";

const RealEstateExample = () => {
  return (
    <ExamplePageTemplate
      backgroundColor={realEstateConfig.backgroundColor}
      chatButtonColor={realEstateConfig.chatButtonColor}
      chatButtonIcon={realEstateConfig.chatButtonIcon}
      header={realEstateConfig.header}
      hero={realEstateConfig.hero}
    >
      {realEstateConfig.content}
    </ExamplePageTemplate>
  );
};

export default RealEstateExample;